import { ajaxFunc } from '../tools';

const agent = {
  // 获取连连钱包的状态信息
  authorize_open_account: ajaxFunc('/agent/authorize_open_account', 'post')
};

export default agent;




// WEBPACK FOOTER //
// ./src/request/api/agent.js